import React from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  required,
  useNotify,
  useRedirect,
} from 'react-admin';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { Business as BusinessIcon } from '@mui/icons-material';

export const EnterpriseCreate = () => {
  const notify = useNotify();
  const redirect = useRedirect();

  const onSuccess = (data: any) => {
    notify('Enterprise created successfully', { type: 'success' });
    redirect(`/enterprises/${data.id}/show`);
  };

  return (
    <Create
      mutationOptions={{ onSuccess }}
      redirect="show"
    >
      <Card sx={{ maxWidth: 800, mx: 'auto', mt: 3 }}>
        <CardContent>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
            <BusinessIcon color="primary" sx={{ fontSize: 32 }} />
            <Typography variant="h5" sx={{ fontWeight: 600 }}>
              Create Enterprise
            </Typography>
          </Box>

          <SimpleForm toolbar={<Box />}>
            <TextInput
              source="name"
              label="Enterprise Name"
              validate={[required()]}
              fullWidth
              helperText="The name of your enterprise organization"
            />

            <TextInput
              source="description"
              label="Description"
              multiline
              rows={3}
              fullWidth
              helperText="Brief description of the enterprise (optional)"
            />

            <TextInput
              source="logoUrl"
              label="Logo URL"
              fullWidth
              helperText="URL to the enterprise logo image (optional)"
            />
          </SimpleForm>
        </CardContent>
      </Card>
    </Create>
  );
};
